import { useSelector, useDispatch } from "react-redux";

import {
  setShowDeleteConfirmationModal,
  setIsProcessing,
  setSelectedReferringProvider,
} from "app/store/referringProvider/slice/referringProviderSlice";
import { useDeleteReferringProviderMutation } from "app/store/referringProvider/api/referringProviderApi";
import { showSuccessToast, showErrorToast } from "utils/toast";

const useDeleteConfirmationModal = () => {
  const {
    showDeleteConfirmationModal,
    selectedReferringProvider,
    isProcessing,
  } = useSelector((state) => state.referringProvider);
  const [deleteReferringProvider] = useDeleteReferringProviderMutation();
  const dispatch = useDispatch();

  const handleModalClose = () => {
    dispatch(setShowDeleteConfirmationModal(false));
    selectedReferringProvider && dispatch(setSelectedReferringProvider(null));
  };

  const handleDeleteReferringProvider = async () => {
    try {
      dispatch(setIsProcessing(true));
      const { message } = await deleteReferringProvider(
        selectedReferringProvider?._id
      ).unwrap();
      showSuccessToast(message);
      handleModalClose();
    } catch (error) {
      showErrorToast(error?.message || "An error occurred.");
    } finally {
      dispatch(setIsProcessing(false));
    }
  };

  return {
    showDeleteConfirmationModal,
    handleModalClose,
    handleDeleteReferringProvider,
    isProcessing,
  };
};

export default useDeleteConfirmationModal;
